import { getAppConfig } from '../../config/apps';
import { createAppTheme } from './createAppTheme';

export { createAppTheme } from './createAppTheme';

// App identity is fixed at build time, so both themes are built once at module
// load and shared as stable references (<Admin> re-themes if they change).
const { brand } = getAppConfig();

export const appLightTheme = createAppTheme(brand, 'light');
export const appDarkTheme = createAppTheme(brand, 'dark');
